import {
    DIRECT_PAYMENT,
    RECEIVE,
    SEND,
    TRACKED_PAYMENT,
} from '../constant/constant';
import { JOBS_PORTAL_PATH } from './paths';
import {
    adminDashboardIcon,
    adminDisputeIcon,
    adminAnalyticsIcon,
    coinIcon,
    companyJobIcon,
    directPaymentIcon,
    disputeIcon,
    getPaidIcon,
    homeIcon,
    onGoingIcon,
    receiveIcon,
    sendIcon,
    trackedPaymentIcon,
} from '../constant/icon';

// Main navigation items shown to every authenticated user.
export const navigation = [
    { id: 'dashboard', name: 'Dashboard', href: '/dashboard', icon: homeIcon },
    { id: 'pay', name: 'Pay', href: '/pay', icon: coinIcon, iconClass: 'rotate-45' },
    {
        id: 'get-paid',
        name: 'Get Paid',
        href: '/get-paid',
        icon: getPaidIcon,
        iconClass: 'rotate-45',
    },
    {
        id: 'on-going',
        name: 'Ongoing',
        href: '/on-going',
        icon: onGoingIcon,
        badgeKey: 'ongoing',
    },
    {
        id: 'dispute',
        name: 'Disputes',
        href: '/dispute',
        icon: disputeIcon,
        badgeKey: 'disputes',
    },
    {
        id: 'company-job',
        name: 'Company Job',
        href: JOBS_PORTAL_PATH,
        icon: companyJobIcon,
    },
];

// Admin-only items rendered as a separate section in the sidebar.
export const adminNavigation = [
    {
        id: 'admin-analytics',
        name: 'Contract Analytics',
        href: '/admin-contract-analytics',
        icon: adminAnalyticsIcon,
    },
    {
        id: 'admin-dashboard',
        name: 'Admin Dashboard',
        href: '/admin-dashboard',
        icon: adminDashboardIcon,
    },
    {
        id: 'admin-dispute',
        name: 'Disputes',
        href: '/admin-dispute',
        icon: adminDisputeIcon,
    },
];

export const homeFilterData = [
    { id: 1, name: SEND, icon: sendIcon },
    { id: 2, name: RECEIVE, icon: receiveIcon },
];
export const RequestFilterData = [
    { id: 1, name: DIRECT_PAYMENT, icon: directPaymentIcon },
    { id: 2, name: TRACKED_PAYMENT, icon: trackedPaymentIcon },
];

export const getPaidPaymentType = [
    { id: 1, name: DIRECT_PAYMENT, value: 'direct-payment' },
    { id: 2, name: TRACKED_PAYMENT, value: 'tracked-payment' },
    // { id: 3, name: 'Send Request', value: 'send-request' },
];

export const mileStoneDuration = [
    // { id: 0, name: '1 Minute', value: "one_minute", timestamp: 2 * 60 },                   // 1 minute in ms
    { id: 1, name: '1 Hour', value: 'one_hour', timestamp: 3600 }, // 1 hour in seconds
    { id: 2, name: '2 Hour', value: 'two_hours', timestamp: 7200 }, // 2 hours in seconds
    { id: 3, name: '3 Hour', value: 'three_hours', timestamp: 10800 }, // 3 hours in seconds
    { id: 4, name: '6 Hour', value: 'six_hours', timestamp: 21600 }, // 6 hours in seconds
    { id: 5, name: '12 Hour', value: 'twelve_hours', timestamp: 43200 }, // 12 hours in seconds
    { id: 6, name: '1 Day', value: 'one_day', timestamp: 86400 }, // 1 day in seconds
    { id: 7, name: '1 Week', value: 'one_week', timestamp: 604800 }, // 1 week in seconds
    { id: 8, name: '1 Month', value: 'one_month', timestamp: 2592000 }, // 30 days in seconds
    { id: 9, name: '2 Month', value: 'two_months', timestamp: 5184000 }, // 60 days in seconds
    { id: 10, name: '6 Month', value: 'six_months', timestamp: 15552000 }, // 180 days in seconds
    { id: 11, name: '1 Year', value: 'one_year', timestamp: 31536000 }, // 365 days in seconds
];

export const filterTypes = [
    'Milestone',
    'Direct Payment',
    'Sending',
    'Receive',
    'Accepted',
    'Rejected',
    'Need Response',
    'Latest',
];
